import * as React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { IStore } from '../../../../../../redux/IStore';
import { flow, map, get, size } from 'lodash';
import { showDestinations, showRegions } from '../../../../../../data/api/api';
import { IDestination, IPolicyApplication, IProduct, IQuotes, ITraveller } from '../../../../../../data/api/models';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import FaInfoCircle from 'react-icons/fa/info-circle';
import { II18nMessages } from '../../../../../../services/branding/models';

interface ISidebarQuoteSummary {
  i18n: II18nMessages;
  policyApplication: IPolicyApplication;
  destinations: IDestination[];
  values: IPolicyApplication;
  product: IProduct;
  quotes: IQuotes;
  channel: any;
  quote: any;
  isAdditionalCover: boolean;
}

class SidebarQuoteSummary extends React.Component<ISidebarQuoteSummary> {
  private renderTrip = () => {
    const { values } = this.props;

    let content = (
      <p>Freespirit</p>
    );
    if (values.going_on_cruise) {
      content = (
        <p>Freespirit Cruise</p>
      );
    }

    return (
      <div className="quote-summary-section">
        <span>
          Product Selected:
        </span>
        <div className="quote-summary-info">
          {content}
        </div>
      </div>
    );
  }
  private renderDestinations = () => {
    const { values, product } = this.props;

    let content = (
      <p>Nothing Selected</p>
    );

    let regionTripType = values.tripType;

    if (product.productCode === 'LSB') {
      regionTripType = 'longstay';
    }

    if (showDestinations(regionTripType) && values.destinations
    ) {
      content = (
        <div>
          {values.destinations.map((destination, key) => (<div key={key}>{destination}</div>))}
        </div>
      );
    }

    if (showRegions(regionTripType) && values.region) {
      content = (
        <div>{product.metadata.regions[ values.region ]}</div>
      );
    }

    return (
      <div className="quote-summary-section">
        <span>
        {showDestinations(regionTripType) ?
          (values.destinations && values.destinations.length > 1 ? 'Destinations:' : 'Destination:') : 'Region:'}
        </span>
        <div className="quote-summary-info">
          {content}
        </div>
      </div>
    );
  }

  private renderTravelDate() {
    const { values } = this.props;

    let content = null;

    if (values.startDate) {
      content = (
        <div>
          {values.startDate}
          {values.tripType === 'single' && values.endDate ? ' - ' + values.endDate : ''}
        </div>
      );
    }

    return (
      <div className="quote-summary-section">
        <span>
          {values.tripType === 'single' ? 'Travel Dates:' : 'Start Date:'}
        </span>
        <div className="quote-summary-info">
          {content}
        </div>
      </div>
    );
  }

  private renderTraveller = (type: string, display: string) => (traveller: ITraveller, key) => {
    let conditions = null;

    if (traveller.screening) {
      conditions = (
        <span className="traveller-conditions"><br />{traveller.screening.meta.conditions.join(', ')}</span>
      );
    }

    return (
      <div key={key}>
        {display} {key + 1}: <em>{traveller.title} {traveller.firstName} {traveller.lastName}</em> ({traveller.dob})
        {conditions}
      </div>
    );
  }

  private renderTravellers = () => {
    const { values, product } = this.props;
    const { travellers } = values;

    if (!travellers || !values.tripType) {
      return null;
    }

    const noTravellerDetailsEntered = travellers[0].title === '' || travellers[0].firstName === '';
    const adults = travellers.filter((traveller) => traveller.type === 'adult');
    const children = travellers.filter((traveller) => traveller.type === 'child');
    const groupTypes = product.metadata[ `group_type_trip_${values.tripType}` ];

    const total = adults.length + children.length;

    let summaryMessage = `${adults.length} ${adults.length > 1 ? 'adults' : 'adult'}`;

    if (children.length) {
      summaryMessage += `, ${children.length} ${children.length > 1 ? 'children' : 'child'}`;
    }

    return (
      <div className="quote-summary-section">
        <span>
          {total > 1 ? 'Travellers:' : 'Traveller:'}
        </span>
        {!noTravellerDetailsEntered && (
          <div className="quote-summary-info">
            <div>{groupTypes[ values.groupType ]} ({summaryMessage})</div>

            {adults.map(this.renderTraveller('adult', 'Adult'))}
            {children.map(this.renderTraveller('child', 'Child'))}
          </div>
        )}
      </div>
    );
  }

  private renderTripType() {
    const { quotes } = this.props;

    return (
      <div className="quote-summary-section">
        Cover Choice:
        <div className="quote-summary-info">
          <div>
            {size(quotes) === 1 && map(quotes, (item, key) => {
              return map(item, (i, key2) => {
                return (<span key={`${key}-${key2}`}>{i.scheme.name}<br/></span>);
              });
            })}
          </div>
        </div>
      </div>
    );
  }

  private renderAdditionalOptions = () => {
    const { values, channel, quote } = this.props;
    const getAllOptions = get(quote, 'application.premiums[0].information.availableOptions');
    const isOnList = ['tpl-b2c'].includes(channel.key);

    const options = map(values.options, (value: any, key) => {
      if (key === 'cruise_cover' && !isOnList) {
        return;
      }

      const productOption = getAllOptions && getAllOptions[key];
      const getOptionsList = getAllOptions && getAllOptions[key];
      const getOptionSelected = getOptionsList && getOptionsList.options &&
        getOptionsList.options.find((o) => o.key === value);
      if (productOption && productOption.input_type && productOption.input_type === 'enum') {
        return (
          <div key={key}>{productOption && productOption.name}: {getOptionSelected && getOptionSelected.name}</div>
        );
      }

      if (productOption && productOption.name && productOption.input_type
        && productOption.input_type === 'boolean' && value === true) {
        return (
          <div key={key}>{productOption && productOption.name}</div>
        );
      }

      if (productOption && productOption.name && productOption.input_type === 'list') {
        const item = productOption.items[value];

        const popover = (
          <Popover
            id={`popover-summary-${key}`}
          >
            {item}
          </Popover>
        );

        const info = (
          <OverlayTrigger
            trigger="click"
            rootClose={true}
            overlay={popover}
            placement="right"
            positionLeft={200}
            positionTop={50}
          >
            <FaInfoCircle className="pointer" />
          </OverlayTrigger>
        );

        return (
          <div key={key}>
            {productOption.name} {info}
          </div>
        );
      }
    }).filter((option) => !!option);

    if (options.length === 0) {
      return null;
    }

    if (values.going_on_cruise) {
      // Instead of pushing an object, return a JSX element
      options.push(
        <div key="cruise_cover">
          Cruise Cover
        </div>,
      );
    }

    return (
      <div className="quote-summary-section">
      <span>
        Additional {options.length > 1 ? 'Options:' : 'Option:'}
      </span>
        <div className="quote-summary-info">
          {options}
        </div>
      </div>
    );
  }

  private renderQuoteReference = () => {
    const { values } = this.props;

    return (
      <div className="quote-summary-section">
        <span>
          Quote Reference:
        </span>
        <div className="quote-summary-info">
          {values.quoteReference}
        </div>
      </div>
    );
  }

  public render() {
    const { channel } = this.props;
    return (
      <div className="quote-details">
        {channel.key === 'fst-b2c' && (
          this.renderTrip()
        )}
        {this.renderDestinations()}
        {this.renderTravelDate()}
        {this.renderTravellers()}
        {this.props.isAdditionalCover && this.renderTripType()}
        {this.renderAdditionalOptions()}
        {this.renderQuoteReference()}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const { quotes, complete } = state.quote;
      const values = selector(
        state,
        'quote',
        'destinations',
        'startDate',
        'endDate',
        'region',
        'tripType',
        'options',
        'travellers',
        'groupType',
        'schemeId',
        'quoteReference',
        'activities',
        'going_on_cruise',
      );

      return {
        i18n: state.branding.i18n,
        quote: state.quote,
        channel: state.branding.channel,
        policyApplication: state.quote.application,
        destinations: state.quote.destinations,
        values,
        quotes,
        complete,
      };
    },
  ),
])(SidebarQuoteSummary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/QuoteSidebar/components/SidebarQuoteSummary/index.tsx